import { hasTranslation, translate } from '@fiverr-private/i18n-react';

export const getI18nText = (key: string | null | undefined, params = {}): string | undefined => {
    const isKeyExists = hasTranslation(key);
    return isKeyExists ? translate(key as string, { params }) : undefined;
};
